import React from "react";
import { Link } from "react-router-dom";

import Helmet from "../../components/Helmet";
import CallToAction from "../../components/CallToAction";
import MidCallToAction from "../../components/MidCallToAction";
import NavbarSettings from "../../components/navbar/NavbarSettings";
import SubPageBanner from "../../components/SubPageBanner";
import HomepageImageText from "../../components/HomepageImageText";
import LaadpaalBanner from "../../img/charger/alfen-vrouw-gebruik.jpg";
import LaadpaalImage from "../../img/charger/ev-charger-banner.jpg";
import blockSeperator from "../../img/svg/block-seperator.svg"

function BidirectioneleLaadpalen() {
    return (
        <React.Fragment>
            <Helmet
                title="Bidirectionele laadpaal"
                description="Ontdek de toekomst van energie met bidirectionele laadpalen. Laad je auto én gebruik hem om je huis van stroom te voorzien of energie aan het net te geven!"
            />

            <NavbarSettings>
                <SubPageBanner title="Bidirectionele laadpalen" image={LaadpaalImage} imgAlt="Afbeelding van een Autel laadpaal" />
            </NavbarSettings>

            <div className="container-orange-background mb-5">
                <div className="container">
                    <HomepageImageText
                        title="Bidirectionele laadpaal"
                        text="De wereld van elektrisch rijden verandert snel, en met de opkomst van bidirectionele laadpalen is een nieuwe fase in energiemanagement aangebroken. Deze technologie maakt het mogelijk om niet alleen je elektrische auto op te laden, maar ook energie uit je auto terug te halen om je huis van stroom te voorzien of zelfs energie aan het net te leveren. Dit opent de deur naar een veel duurzamere en efficiëntere manier van omgaan met energie. Bidirectioneel laden is niet alleen een slimme keuze voor de toekomst, maar het maakt ook de overstap naar een groenere wereld toegankelijker. Benieuwd hoe deze innovatieve technologie werkt en wat het voor jou kan betekenen? Lees verder en ontdek waarom een bidirectionele laadpaal de toekomst van energie is!"
                        img={LaadpaalBanner}
                        imgAlt="Vrouw die een bidirectionele laadpaal aansluit op een elektrische auto"
                        coverImage
                    />
                </div>
            </div>

            <div>
                <div className="container container-sm">

                    <h3>Wat is een bidirectionele laadpaal?</h3>
                    <p>
                        Een bidirectionele laadpaal is een innovatieve laadoplossing voor elektrische voertuigen (EV’s) waarmee je niet alleen je auto oplaadt, maar ook energie kunt terughalen uit je voertuig om je huis van stroom te voorzien of zelfs energie terug te leveren aan het net.
                        Deze technologie opent nieuwe mogelijkheden voor energiebeheer en kan helpen bij het verlagen van energiekosten en het bevorderen van duurzame energie.
                        Maar hoe werkt dit precies? En wat heb je nodig om te profiteren van deze geavanceerde technologie?
                    </p>

                    <h3>De werking van bidirectioneel laden</h3>
                    <p>
                        Bidirectioneel laden komt in verschillende vormen die allemaal diverse voordelen bieden.
                        De drie belangrijkste vormen zijn V2L (Vehicle to Load), V2H (Vehicle to House) en V2G (Vehicle to Grid).
                        Iedere methode heeft zijn eigen toepassingen en mogelijkheden.
                    </p>
                    <ul>
                        <li>V2L staat voor "Vehicle to Load", waarbij je energie direct uit je voertuig haalt om apparatuur van stroom te voorzien, zoals tijdens een kampeertrip.</li>
                        <li>V2H staat voor "Vehicle to House" en betekent dat je je huis van energie kunt voorzien via je elektrische auto, vergelijkbaar met een thuisbatterij.</li>
                        <li>V2G staat voor "Vehicle to Grid", wat betekent dat je je overtollige energie terug kunt leveren aan het energienet, wat nieuwe mogelijkheden biedt voor energiemanagement en zelfs handel in energie.</li>
                    </ul>
                </div>

                <div className="container">
                    <MidCallToAction />
                </div>

                <div className="container container-sm">
                    <h4 className="text-muted mt-5">V2L: Van voertuig naar apparatuur</h4>
                    <p>
                        Met V2L (Vehicle 2 Load) kun je elektrische apparaten direct aansluiten op je elektrische auto om ze van stroom te voorzien.
                        Je plugt de stekker rechtstreeks in de auto, zonder tussenkomst van een laadpaal. Stel je voor dat je aan het kamperen bent en je je airfryer, koffiezetapparaat of ander elektrisch apparaat wilt gebruiken.
                        Met V2L fungeert je auto als mobiele energiebron. Ideaal voor wie graag op avontuur gaat zonder in te leveren op comfort.
                    </p>
                    <h4 className="text-muted">V2H: Van voertuig naar huis</h4>
                    <p>
                        Een van de meest indrukwekkende toepassingen van bidirectioneel laden is V2H (Vehicle to House).
                        Hiermee kun je je woning voorzien van stroom via je elektrische voertuig.
                        Het werkt vrijwel hetzelfde als een thuisbatterij, maar met een veel grotere capaciteit.
                        Heb je bijvoorbeeld zonnepanelen op je dak? Dan kun je de overtollige zonne-energie opslaan in je auto en gebruiken wanneer het nodig is, bijvoorbeeld 's avonds of op een bewolkte dag.
                        Het is een efficiënte manier om zelfvoorzienend te worden op het gebied van energie.
                    </p>
                    <h4 className="text-muted">V2G: Van voertuig naar het net</h4>
                    <p>
                        Met V2G (Vehicle to Grid) kun je zelfs energie terugleveren aan het net. Dit biedt een aantal interessante mogelijkheden voor de toekomst, vooral voor mensen met een dynamisch energiecontract.
                        Stel je voor dat je je elektrische auto oplaadt wanneer de prijzen laag zijn en energie teruggeeft aan het net wanneer de prijzen hoog zijn.
                        Dit kan niet alleen voordelig zijn voor je eigen portemonnee, maar helpt ook het energienet te balanceren.
                        In de toekomst wordt verwacht dat meer technologieën zoals GridSense deze functie verder zullen ondersteunen, zodat je nog meer controle hebt over je energieverbruik en -productie.
                    </p>
                </div>

                <div className="w-full" style={{ height: 200, position: "relative" }}>
                    <img src={blockSeperator} alt="Block seperator" style={{ width: "100%", position: "absolute", objectFit: "cover", bottom: 0 }} />
                </div>
            </div>
            <div className="container-white-background pt-0">
                <div className="container container-sm">
                    <h3>Wat heb je nodig voor bidirectioneel laden?</h3>
                    <p>
                        Om te profiteren van bidirectioneel laden, zijn er een aantal voorwaarden waaraan je moet voldoen.
                        Ten eerste moet je elektrische auto deze technologie ondersteunen.
                        Niet alle elektrische voertuigen bieden de mogelijkheid om energie terug te leveren, dus het is belangrijk om te controleren of jouw model geschikt is.
                        Daarnaast heb je een laadpaal nodig die bidirectioneel laden ondersteunt.
                    </p>

                    <h3>Bidirectionele laadpalen bij Smith Solar</h3>
                    <p>
                        Hoewel de technologie voor bidirectioneel laden al in opkomst is, zijn er momenteel nog maar weinig laadpalen beschikbaar die deze functionaliteit ondersteunen.
                        Bij Smith Solar volgen we de ontwikkelingen op de voet en werken we er hard aan om deze technologie voor onze klanten beschikbaar te stellen.
                        Zodra we de juiste laadpalen kunnen leveren, kom je dit te weten op deze pagina. 
                        
                        Heb je nog vragen over bidirectionele laadpalen of heb je interesse in de aankoop van een standaard laadpaal?
                        Neem dan <Link to="/contact/">contact</Link> op met Smith Solar of vraag meteen een <Link to="/offerte/">offerte</Link> aan voor een overzicht van de kosten.
                    </p>
                </div>
            </div>

            <CallToAction />
        </React.Fragment>
    );
}

export default React.memo(BidirectioneleLaadpalen);
